import { render, staticRenderFns } from "./PrivateSalesPage.vue?vue&type=template&id=33c05ae2&"
import script from "./PrivateSalesPage.vue?vue&type=script&lang=js&"
export * from "./PrivateSalesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports